export const baseURL = "/api/v1";
// export const baseURL = "http://localhost:5000/api/v1";
